"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionTarget = void 0;
var format_error_1 = require("./format-error");
/** Represents the association of a condition to a specific target entity. */
var ConditionTarget = /** @class */ (function () {
    /**
    * Creates the association of a condition to a specific target entity.
    * @param condition The condition the target is for.
    * @param target The target entity the condition is associated with.
    * @param properties The set of properties on the target entity the condition is related to.
    */
    function ConditionTarget(condition, target, properties) {
        this.condition = condition;
        this.target = target;
        this.properties = properties;
        // Attach the condition target to the target entity.
        if (this.condition.type !== format_error_1.FormatError.ConditionType) {
            target.meta.setCondition(this);
        }
    }
    return ConditionTarget;
}());
exports.ConditionTarget = ConditionTarget;
